import { isThemeEditor } from '../../utils';
import { APP_BLOCK_CONTAINER } from './utils';

const text = 'Upsell add-ons will be here';
const css = `
    <style>
        .${APP_BLOCK_CONTAINER}:empty {
            display: block !important; /* Show in all themes */
            background: aliceblue;
            padding: 40px;
            text-align: center;
        }
        
        .${APP_BLOCK_CONTAINER}:empty:after {
            content: '${text}';
        }
    </style>
  `;

export default function injectThemeEditorStyles() {
  if (!isThemeEditor()) {
    return;
  }

  document.querySelector('head').insertAdjacentHTML('beforeend', css);
}
